<div class="cultureDetails_container"  >
  @if (isLoading){
      <div class="cultureDetails_loadingStateText"></div>
  }
  @if (cultuerDetails && !isLoading){
    <div class="cultureDetails_contentContainer">
      <div class="cultureDetails_headerContainer">
        <mat-icon class="cultureDetails_headerIcon">{{cultuerDetails.imageUrl}}</mat-icon>
        <span class="cultureDetails_header">{{ cultuerDetails.header }}</span> 
      </div>
      <span class="cultureDetails_description">{{ cultuerDetails.description }}</span>  
    </div>
  }
</div>
